import React, { useContext } from "react";
import { Route, Switch, withRouter, BrowserRouter } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { chunk } from "react-chunk";
import { getUserGroup } from "../utilities/storage";
import { AuthContext } from "../globalState/index";

import "./App.scss";
import "antd/dist/antd.css";

import { Layout } from "antd";

import homeIcon from "../assets/images/header/up-arrow.png";
import productIcon from "../assets/images/header/product.png";
import cartIcon from "../assets/images/header/supermarket.png";
import orderIcon from "../assets/images/header/order.png";
import notificationIcon from "../assets/images/header/bell.png";
import Redirect from "./dealer/OrderPlaced/components/Redirect";

// shared
const NotFound = chunk(() => import("./shared/NotFound"))();
const Login = chunk(() => import("./Login"))();
const AboutUs = chunk(() => import("./shared/AboutUs"))();
const ContactUs = chunk(() => import("./shared/ContactUs"))();
const TermsOfUse = chunk(() => import("./shared/TermsOfUse"))();
const PrivacyStatement = chunk(() => import("./shared/PrivacyStatement"))();
const ResetPassword = chunk(() => import("./shared/ResetPassword"))();
const AccountActivation = chunk(() => import("./shared/AccountActivation"))();

// dealer
const DealerHeader = chunk(() => import("./dealer/shared/Header"))();
const DealerFooter = chunk(() => import("./dealer/shared/Footer"))();
const DealerDrawer = chunk(() => import("./dealer/shared/Drawer"))();

const Home = chunk(() => import("../components/dealer/Home"))();
const Product = chunk(() => import("../components/dealer/Product"))();
const Cart = chunk(() => import("../components/dealer/Cart"))();
const Order = chunk(() => import("../components/dealer/Order"))();
const Notification = chunk(() => import("../components/dealer/Notification"))();
const OrderTracking = chunk(() =>
  import("../components/dealer/OrderTracking")
)();
const OrderPlaced = chunk(() => import("../components/dealer/OrderPlaced"))();
const AccountsPayable = chunk(() =>
  import("../components/dealer/AccountsPayable")
)();
const DealerProfile = chunk(() => import("../components/dealer/Profile"))();

// distributor
const DistributorHeader = chunk(() => import("./distributor/shared/Header"))();
const DistributorFooter = chunk(() => import("./distributor/shared/Footer"))();
const DistributorDrawer = chunk(() => import("./distributor/shared/Drawer"))();
const Sider = chunk(() => import("./distributor/shared/Sider"))();

const AllOrder = chunk(() => import("../components/distributor/AllOrder"))();
const AccountReceivable = chunk(() =>
  import("../components/distributor/AccountsReceivable")
)();
const Employee = chunk(() => import("../components/distributor/Employee"))();
const DeliverySchedules = chunk(() =>
  import("../components/distributor/DeliverySchedule")
)();
const Dealer = chunk(() => import("../components/distributor/Dealer"))();
const Inventory = chunk(() => import("../components/distributor/Inventory"))();
const SalesReport = chunk(() =>
  import("../components/distributor/SalesReport")
)();
const OrderStatus = chunk(() =>
  import("../components/distributor/OrderStatus")
)();
const InventoryReport = chunk(() =>
  import("../components/distributor/InventoryReport")
)();
const AccountsReceivableReport = chunk(() =>
  import("../components/distributor/AccountsReceivableReport")
)();

const dealerPaths = [
  {
    default: true,
    exact: true,
    slug: "home",
    route: "/",
    label: "Home",
    icon: homeIcon,
    component: Home,
  },
  {
    default: true,
    exact: true,
    slug: "product",
    route: "/product",
    label: "Product",
    icon: productIcon,
    component: Product,
  },
  {
    default: true,
    exact: true,
    slug: "cart",
    route: "/cart",
    label: "My Cart",
    icon: cartIcon,
    component: Cart,
  },
  {
    default: true,
    exact: true,
    slug: "order",
    route: "/order",
    label: "Order",
    icon: orderIcon,
    component: Order,
  },
  {
    default: true,
    exact: true,
    slug: "notification",
    route: "/notification",
    label: "Notification",
    icon: notificationIcon,
    component: Notification,
  },
  {
    default: true,
    exact: true,
    slug: "order-tracking",
    route: "/order-tracking/:po_id",
    label: "OrderTracking",
    icon: "",
    component: OrderTracking,
  },
  {
    default: true,
    exact: true,
    slug: "order-placed",
    route: "/order-placed/:po_id/:user_id",
    label: "OrderPlaced",
    icon: "",
    component: OrderPlaced,
  },
  {
    default: true,
    exact: true,
    slug: "accounts-payable",
    route: "/accounts-payable",
    label: "AccountsPayable",
    icon: "",
    component: AccountsPayable,
  },
  {
    default: true,
    exact: true,
    slug: "about-us",
    route: "/about-us",
    label: "AboutUs",
    icon: "",
    component: AboutUs,
  },
  {
    default: true,
    exact: true,
    slug: "contact-us",
    route: "/contact-us",
    label: "ContactUs",
    icon: "",
    component: ContactUs,
  },
  {
    default: true,
    exact: true,
    slug: "terms-of-use",
    route: "/terms-of-use",
    label: "TermsOfUse",
    icon: "",
    component: TermsOfUse,
  },
  {
    default: true,
    exact: true,
    slug: "privacy-statement",
    route: "/privacy-statement",
    label: "PrivacyStatement",
    icon: "",
    component: PrivacyStatement,
  },
  {
    default: true,
    exact: true,
    slug: "profile",
    route: "/profile",
    label: "Profile",
    icon: "",
    component: DealerProfile,
  },
];

const distributorPaths = [
  {
    belongsTo: "orders",
    default: true,
    exact: true,
    slug: "all-order",
    route: "/",
    label: "All Order",
    icon: "all-order",
    component: AllOrder,
  },
  {
    belongsTo: "orders",
    default: true,
    exact: true,
    slug: "new-orders",
    route: "/new-orders",
    label: "New Orders",
    icon: "new-orders",
    component: AllOrder,
  },
  {
    belongsTo: "orders",
    default: true,
    exact: true,
    slug: "on-hold",
    route: "/on-hold",
    label: "On Hold",
    icon: "on hold",
    component: AllOrder,
  },
  {
    belongsTo: "orders",
    default: true,
    exact: true,
    slug: "delivery",
    route: "/delivery",
    label: "Delivery",
    icon: "delivery",
    component: AllOrder,
  },
  {
    belongsTo: "orders",
    default: true,
    exact: true,
    slug: "pickup",
    route: "/pickup",
    label: "Pick Up",
    icon: "pick-up",
    component: AllOrder,
  },
  {
    belongsTo: "orders",
    default: true,
    exact: true,
    slug: "delivered",
    route: "/delivered",
    label: "Delivered",
    icon: "delivered",
    component: AllOrder,
  },
  {
    belongsTo: "orders",
    default: true,
    exact: true,
    slug: "pickedup",
    route: "/pickedup",
    label: "Picked Up",
    icon: "picked-up",
    component: AllOrder,
  },
  {
    belongsTo: "orders",
    default: true,
    exact: true,
    slug: "cancelled",
    route: "/cancelled",
    label: "Cancelled",
    icon: "cancelled",
    component: AllOrder,
  },
  {
    belongsTo: "",
    default: true,
    exact: true,
    slug: "account-receivable",
    route: "/accounts-receivable",
    label: "Account Receivable",
    icon: "accounts-receivable",
    component: AccountReceivable,
  },
  {
    belongsTo: "",
    default: true,
    exact: true,
    slug: "employee",
    route: "/employee",
    label: "Employee",
    icon: "aemployee",
    component: Employee,
  },
  {
    belongsTo: "",
    default: true,
    exact: true,
    slug: "delivery-schedules",
    route: "/delivery-schedules",
    label: "Delivery Schedules",
    icon: "delivery-schedules",
    component: DeliverySchedules,
  },
  {
    belongsTo: "reports",
    default: true,
    exact: true,
    slug: "sales-report",
    route: "/sales-report",
    label: "Sales Report",
    icon: "sales-report",
    component: SalesReport,
  },
  {
    belongsTo: "reports",
    default: true,
    exact: true,
    slug: "accounts-receivable-report",
    route: "/accounts-receivable-report",
    label: "Accounts Receivable Report",
    icon: "accounts-receivable-report",
    component: AccountsReceivableReport,
  },
  {
    belongsTo: "reports",
    default: true,
    exact: true,
    slug: "inventory-report",
    route: "/inventory-report",
    label: "Inventory Report",
    icon: "inventory-report",
    component: InventoryReport,
  },
  {
    belongsTo: "products",
    default: true,
    exact: true,
    slug: "inventory",
    route: "/inventory",
    label: "Inventory",
    icon: "inventory",
    component: Inventory,
  },
  {
    belongsTo: "",
    default: true,
    exact: true,
    slug: "order-status",
    route: "/order-status/:po_id",
    label: "Order Status",
    icon: "order-status",
    component: OrderStatus,
  },
  {
    belongsTo: "dealers",
    default: true,
    exact: true,
    slug: "daeler",
    route: "/dealer",
    label: "Dealer",
    icon: "daeler",
    component: Dealer,
  },
  {
    default: true,
    exact: true,
    slug: "about-us",
    route: "/about-us",
    label: "AboutUs",
    icon: "",
    component: AboutUs,
  },
  {
    default: true,
    exact: true,
    slug: "contact-us",
    route: "/contact-us",
    label: "ContactUs",
    icon: "",
    component: ContactUs,
  },
  {
    default: true,
    exact: true,
    slug: "terms-of-use",
    route: "/terms-of-use",
    label: "TermsOfUse",
    icon: "",
    component: TermsOfUse,
  },
  {
    default: true,
    exact: true,
    slug: "privacy-statement",
    route: "/privacy-statement",
    label: "PrivacyStatement",
    icon: "",
    component: PrivacyStatement,
  },
];

export default withRouter(function App(props) {
  const [state] = useContext(AuthContext);

  const sm = useMediaQuery({ query: "(max-width: 576px)" });
  const md = useMediaQuery({ query: "(max-width: 768px)" });
  const lg = useMediaQuery({ query: "(max-width: 992px)" });
  const drawerViewport = useMediaQuery({ query: "(max-width: 600px)" });

  function findedKey() {
    const ref = distributorPaths.find(
      (row) => props.location.pathname === row.route
    );
    switch (ref) {
      case undefined:
        return [".", "."];
        break;
      default:
        return [ref.belongsTo, ref.slug];
    }
  }

  function isRender() {
    return [
      "/about-us",
      "/contact-us",
      "/terms-of-use",
      "/privacy-statement",
    ].includes(props.location.pathname);
  }

  return !state.isAuthenticated ? (
    <BrowserRouter>
      <Switch>
        {window.scrollTo(0, 0)}
        <Route
          exact
          path="/set-up-password/:user_id/:time_sent"
          component={AccountActivation}
        />
        <Route
          exact
          path="/reset-password/:user_id/:time_sent"
          component={ResetPassword}
        />
        <Route path="/" component={Login} />
      </Switch>
    </BrowserRouter>
  ) : Number(getUserGroup()) === 2 ? (
    <Layout className={`distributor-layout ${isRender() && "customize"}`}>
      {!md ? (
        !isRender() && (
          <Sider
            {...props}
            paths={distributorPaths}
            keys={findedKey()}
            viewport={{ sm, md, lg, drawerViewport }}
          />
        )
      ) : (
        <DistributorDrawer
          {...props}
          paths={distributorPaths}
          viewport={{ sm, md, lg, drawerViewport }}
          keys={findedKey()}
        />
      )}
      <DistributorHeader
        {...props}
        paths={distributorPaths}
        viewport={{ sm, md, lg, drawerViewport }}
      />

      <Layout className="sub-layout">
        <Layout.Content className="sub-layout-content fade-in">
          <Switch>
            {window.scrollTo(0, 0)}
            {distributorPaths.map((path) => (
              <Route
                key={path.slug}
                exact={path.exact}
                path={path.route}
                component={path.component}
              />
            ))}
            <Route component={NotFound} />
          </Switch>
        </Layout.Content>
        <DistributorFooter {...props} paths={distributorPaths} />
      </Layout>
    </Layout>
  ) : (
    <Layout className="dealer-layout">
      <DealerDrawer
        paths={dealerPaths.filter(
          (row) =>
            ![
              "order-tracking",
              "order-placed",
              "accounts-payable",
              "about-us",
              "contact-us",
              "terms-of-use",
              "privacy-statement",
              "profile",
            ].includes(row.slug)
        )}
      />
      <DealerHeader
        {...props}
        paths={dealerPaths.filter(
          (row) =>
            ![
              "order-tracking",
              "order-placed",
              "accounts-payable",
              "about-us",
              "contact-us",
              "terms-of-use",
              "privacy-statement",
              "profile",
            ].includes(row.slug)
        )}
        viewport={{ sm, md, lg, drawerViewport }}
      />
      <Layout.Content className="content fade-in">
        <Switch>
          {window.scrollTo(0, 0)}
          {dealerPaths.map((path) => (
            <Route
              key={path.slug}
              exact={path.exact}
              path={path.route}
              component={path.component}
            />
          ))}
          <Route component={NotFound} />
        </Switch>
      </Layout.Content>
      <DealerFooter {...props} paths={dealerPaths} />
    </Layout>
  );
});
